import { render, staticRenderFns } from "./SearchGlobal.vue?vue&type=template&id=5df46080&scoped=true&"
import script from "./SearchGlobal.vue?vue&type=script&lang=js&"
export * from "./SearchGlobal.vue?vue&type=script&lang=js&"
import style0 from "./SearchGlobal.vue?vue&type=style&index=0&id=5df46080&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df46080",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDialog,VIcon,VNavigationDrawer,VRow})
